import React, { Component} from 'react'
import { connect } from 'react-redux'
import {addExternalSignin,removeExternalSignin} from '../../actions/user'
import {hideModal} from '../../actions/modals'
import {showNotification} from '../../actions/notifications'
import VerifyWithPasswordForm from '../../components/forms/account/VerifyWithPasswordForm'
import Button from '../../components/uiKit/Button'
import FeatureModalSelectControl from '../../components/featureModals/FeatureModalSelectControl'
import errorMessages from '../../staticData/errorMessages.js'


class AppleAccountAuthenticationContainer extends Component {

	constructor(){
		super()
		this.addApple=this.addApple.bind(this)
		this.removeApple=this.removeApple.bind(this) 
		this.state = {
			submitLoading:false,
			errorMessage:null,
			logOut:false
		}
	}

	addApple(formData){
		this.setState({submitLoading:true,errorMessage:null})
		const requestData={
			type:'apple',
			idToken:this.props.data.authorization['id_token'],
			password:formData.currentPassword
		}
		this.props.addExternalSignin(this.props.user.id,requestData,'apple').then((response) => {
			this.props.hideModal()
		 	this.props.showNotification('Apple Sign in access to your account','Added','default')
		})
		.catch(error => {
			this.props.hideModal()
			let errorMessage='Something went wrong. Could not add Apple Sign in access.'
			if(errorMessages.accountErrors.addAppleSignin[error.response.status]){
		 		errorMessage=`${errorMessages.accountErrors.addAppleSignin[error.response.status]}`
			}
			this.props.showNotification(errorMessage,'Error:','destroy')
		})
	}


	removeApple(formData){
		this.setState({submitLoading:true,errorMessage:null})
		const requestData={
			type:'apple',
			password:formData.currentPassword
		}
		this.props.removeExternalSignin(this.props.user.id,requestData,this.state.logOut).then((response) => {
			this.props.hideModal()
			this.props.showNotification('','Succesfully removed Apple Sign-in','default')		
		})
		.catch(error => {
			let errorMessage='Something went wrong'
			if(errorMessages.accountErrors.addAppleSignin[error.response.status]){
		 		errorMessage=`${errorMessages.accountErrors.addAppleSignin[error.response.status]}`
			}
	 		this.setState({submitLoading:false,errorMessage:errorMessage})
		})
	}



	render() {
		const {data}=this.props
		const {errorMessage,submitLoading}=this.state
		let method='remove'
		let formSubmit=this.removeApple
		let user=null
		if(data){
			method='add'
			formSubmit=this.addApple
			if(data.user){
				user=data.user
			}
		}

		return (
			 <div className={'accountAuthentication ' + (method ? `is--${method}` : '')}>     
				
				{method==='add' && user &&
					<div className='accountAuthentication-selectedGoogleAccountCard accountAuthentication-selectedGoogleAccountCard--apple'>
						Selected Apple Account
						<div className='accountAuthentication-selectedGoogleAccountCard-card'>
							<div className='accountAuthentication-selectedGoogleAccountCard-card-details'>							
								<div className='accountAuthentication-selectedGoogleAccountCard-card-details-name'>
									{user.name.firstName} {user.name.lastName}
								</div>								
								<div className='accountAuthentication-selectedGoogleAccountCard-card-details-email'>
									{user.email}
								</div>
							</div>            
						</div>
					</div>
				}

				{method==='add' &&	!user &&
					<div className='accountAuthentication-confirmText'>
						<br/><br/>
						<b>Please confirm you want to add Apple Sign-in.</b>
						<br/><br/><br/><br/>
					</div> 
				}	

				{method==='remove' &&
					<div className='accountAuthentication-confirmText'>
						<b>Please provide your Plickers password to remove Apple Sign-in.</b>
					</div> 
				}

				{method !=='add' &&			
					<VerifyWithPasswordForm
						externalSiginType='apple'
						onSubmit={formSubmit}
						method={method}
						submitLoading={submitLoading}
					/>
				}

				{method==='remove' && 
					<div className='accountAuthentication-signOutEverywhere'>
						<FeatureModalSelectControl
							checkbox
							checked={this.state.logOut}
							onClick={()=>(this.setState({logOut:!this.state.logOut}))}
							label='Require all devices to sign in again'
						/>		
					</div>
				}  

				{method ==='add' &&		
    				<Button 
    					onClickFunction={this.addApple}
    					submitLoading={submitLoading}
    					size='large'
    					label={'Confirm'}
    					color={'blue'}
    					type='submit'>
    				</Button>	        		
				}

				{method==='add' && !errorMessage &&
					<div className='accountAuthentication-confirmBtnExplainer'>
							After confirming, you will be able to sign in with both your Apple account and your existing email address and password.
					</div>
				}

				{method==='remove' && !errorMessage &&
					<div className='accountAuthentication-confirmBtnExplainer'>
							After removing Apple Sign-in, you will be only be able to sign in with the existing email address and password associated with your Plickers account.
					</div>
				}  

				{errorMessage &&
					<div className='accountAuthentication-error'>
						{errorMessage}
					</div>
				}

			</div>
		)
	}
}
 
export default connect(
	(state,ownProps) => ({
		user:state.user,
		data:state.modals.data,
		meta:state.meta
	}),
		{addExternalSignin,
		hideModal,
		removeExternalSignin,
		showNotification}
)(AppleAccountAuthenticationContainer)